import { atom } from "recoil"
import { initializeCalibrationState } from "../Calibration/state"
import type { EEGCalibrationState } from "../Calibration/types"

export const eegCalibrationAtom = atom<EEGCalibrationState>({
	key: "eegCalibration",
	default: initializeCalibrationState(),
})
